import { Component, Input, OnChanges, inject } from '@angular/core';

import { IconService } from './icon.service';

@Component({
  selector: 'digital-platform-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnChanges {
  private iconService = inject(IconService);
  @Input() color = '';
  @Input() icon = '';
  @Input() width = 24;
  @Input() height = 24;

  public fillColorClass = '';
  public iconUrl = '';
  public viewBox: string | undefined = '';

  public ngOnChanges() {
    const iconData = this.iconService.getIcon(this.icon);
    if (iconData) {
      this.iconUrl = iconData.svgPath;
      this.viewBox = iconData.viewBox;
      this.fillColorClass = `fill-${this.color}`;
    }
  }
}
